import { Injectable } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes } from 'common-cloudstudio';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanServiceService {
  graphicalView: CoreTypes.GraphicalView = new CoreTypes.GraphicalView();
  _endpointsFullList: BehaviorSubject<CoreTypes.SimpleEndpoint[]> = new BehaviorSubject([]);
  _graphicalViewFullList: BehaviorSubject<CoreTypes.GraphicalView[]> = new BehaviorSubject([]);
  _endpointsStatus = 0;
  _graphicalViewStatus = 0;

  constructor(
    public _appService: AppService,
    public coreProxyService: CoreProxyService,
  ) {
    this._appService.onFacilitySet.subscribe(() => {
      this._endpointsFullList.value.length = 0;
      this._graphicalViewFullList.value.length = 0;
      this._endpointsStatus = 0;
      this._graphicalViewStatus = 0;
    })
  }

  cloneSelectedElement(selectedElements:CoreTypes.GraphicalViewPlanElement[]):
    Observable<CoreTypes.GraphicalViewPlanElement[]> {
    const clonedElements: CoreTypes.GraphicalViewPlanElement[] = [];
    this._appService.startLoading();
    return new Observable((observer) => {
      selectedElements.forEach(async (item, index) => {
        const newElement: CoreTypes.GraphicalViewPlanElement = JSON.parse(JSON.stringify(item));
        if(newElement.GraphicalViewPlanElementID !== 0){
          newElement.PositionX += 10;
          newElement.PositionY += 10;
        }
        newElement.GraphicalViewPlanElementID = 0;
        if (newElement.PlanElementTypeID === CoreTypes.PlanElementType.Image) {
          let data: CoreTypes.GraphicalViewPlanImageElement = JSON.parse(newElement.JsonData);
          data.Image.ContentBase64 = (await this.getBase64FromUrl(data.Image.Url)).split(',')[1];
          newElement.JsonData = JSON.stringify(data);
        } else if (newElement.PlanElementTypeID === CoreTypes.PlanElementType.EndpointStatusImage) {
          let data: CoreTypes.GraphicalViewPlanEndpointStatusImage = JSON.parse(newElement.JsonData);
          for (const key of Object.keys(data)) {
            if (!data[key] || !data[key].Url) { continue; }
            if (key === 'ScalarRangesImages') {
              for (const range of data.ScalarRangesImages) {
                if (!range || !range.Image.Url) { continue; }
                range.Image.ContentBase64 = (await this.getBase64FromUrl(range.Image.Url)).split(',')[1];
              }
            } else {
              data[key].ContentBase64 = (await this.getBase64FromUrl(data[key].Url)).split(',')[1];
            }
          };
          newElement.JsonData = JSON.stringify(data);
        } else if (newElement.PlanElementTypeID === CoreTypes.PlanElementType.Alarms) {
          let data: CoreTypes.GraphicalViewPlanAlarmsElement = JSON.parse(newElement.JsonData);
          for (const key of Object.keys(data)) {
            if (!data[key] || !data[key].Url) { continue; }
            if (['EndpointIDs', 'Scope'].indexOf(key) === -1) {
              data[key].ContentBase64 = (await this.getBase64FromUrl(data[key].Url)).split(',')[1];
            }
          };
          newElement.JsonData = JSON.stringify(data);
        }
        clonedElements.push(newElement);
        if (index === selectedElements.length-1) { observer.next(clonedElements); }
      });
    });
  }

  storeGraphicalViewPlanElements(clonedElements:CoreTypes.GraphicalViewPlanElement[], graphicalViewId:number ):
    Observable<CoreTypes.GraphicalViewPlanElement[]> {
    return new Observable(observer => {
      this.coreProxyService.GraphicalViewService.StoreGraphicalViewPlanElements(
        this._appService.getAccessToken(),
        graphicalViewId,
        clonedElements,
        res => {
          this._appService.stopLoading();
          observer.next(res);
        },
        (err) => {
          observer.error(err);
          this._appService.showException(err);
          this._appService.stopLoading();
        }
      )
    })
  }

  async getBase64FromUrl(url: string): Promise<any> {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

  getEndpointList(): Promise<CoreTypes.SimpleEndpoint[]> {
		return new Promise((resolve, reject) => {
			if (this._endpointsFullList.value.length || this._endpointsStatus === 1) {
				return resolve(this._endpointsFullList.value);
			}
			this._endpointsStatus = 1;
      this.coreProxyService.DeviceService.EnumSimpleEndpointsForFacility(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        data => {
          this._endpointsFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  getGraphicalViews(): Promise<CoreTypes.GraphicalView[]> {
    return new Promise((resolve, reject) => {
			if (this._graphicalViewFullList.value.length || this._graphicalViewStatus === 1) {
				return resolve(this._graphicalViewFullList.value);
			}
      this._graphicalViewStatus = 1;
      this.coreProxyService.GraphicalViewService.EnumGraphicalViews(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        data => {
          this._graphicalViewFullList.next(data)
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      );
    })
  }
}
